<template>
  <div class="addType-container">
    <cTab v-bind="$attrs" v-on="$listeners"></cTab>
    <div class='addType-tabWrapper'>
      <div class="addType-tabWrapper-tips">
        属性：{{ typeTipList[nowCustomType-1] }}
      </div>
      <!-- 内容 -->
      <div class="addType-tabWrapper-content">
        <component
          :is="getComponents"
          :ref="getComponents+'Ref'"
          @refresh = "$emit('refresh')"
          :nowCustomType="nowCustomType"
          :key="nowCustomType"
          :isEdit="isEdit"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
  import cTab from "./add-c-tab.vue"
  import dataCtypeDate from "./add-c-type-date.vue"  // 日期类型
  import dataCtypeNumber from "./add-c-type-number.vue"  // 数值类型
  import dataCtypeSelect from "./add-c-type-select.vue"  // 下拉类型
  export default {
    components:{
      cTab,dataCtypeDate,dataCtypeNumber,dataCtypeSelect
    },
    props:{
    },
    data() {
      return {
        typeTipList:[
          "该项可以输入无样式的单行文本",
          "设置后，该项可以选择日期或期间",
          "该项手动输入或对已有数据进行计算结果",
          "设置后，该项可以下拉选择或搜索预设好的辅助选项",
          "该项可以上传总大小10M以内不限数量的图片",
          "设置后，该项可直接点击预设好的备选按钮（最多5项）",
        ],
        isEdit:false
      }
    },
    computed:{
      nowCustomType() {
        return  this.$attrs.nowCustomType;
      },
      getComponents() {
        let nowCustomType = Number(this.$attrs.nowCustomType),com = "";
        switch(nowCustomType) {
          case 2:  // 日期
            com = "dataCtypeDate";
            break;
          case 3:  // 数值
            com = "dataCtypeNumber";
            break;
          case 4:  // 下拉选项
          case 6:  // 按钮选项
            com = "dataCtypeSelect";
            break;
          default:
            break;
        }
        return com;
      }
    },
    methods:{
      // 设置值
      setNowValue(val,type) {
        let data = {};
        console.log(val,type)
        if(type===3) {  // 数值设置
          data = Object.assign({},data,{
            valueType:val.valueType+"",
            formula:val.formula,
            formulaName:val.formulaName,
            decimalNum_s:val.decimalNum_s?true:false,
            decimalNum:val.decimalNum,
            unit:val.unit,
            isTotal:val.isTotal?true:false,
            unitType:val.unit?"2":"1",
          })
          this.$refs[this.getComponents+'Ref'].getAllNuberType(val.id);
          this.$refs[this.getComponents+'Ref'].shouqiAll = false; // 关闭自动计算选卡
        }else {  // 选项&&按钮设置
          data = Object.assign({},data,{
            isChoice:val.isChoice+"",  // 0 单选 1多选
            optionList:this.$lodash.cloneDeep(val.optionList),  // 选项列表
          })
          this.$refs[this.getComponents+'Ref'].setArr(val.optionList);
          this.$refs[this.getComponents+'Ref'].customColumnId = val.id;
        }
        this.$refs[this.getComponents+'Ref'].form = data;
      },
      // 获取值
      getNowValue() {
        let data = this.$refs[this.getComponents+'Ref'].form;
        return data;
      }
    }
  }
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/dialogComponents/add-c-type.vue